import { render, staticRenderFns } from "./IconPrinter.vue?vue&type=template&id=4baf86f5&scoped=true&"
import script from "./IconPrinter.vue?vue&type=script&lang=js&"
export * from "./IconPrinter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf86f5",
  null
  
)

export default component.exports